import { LANDING_BY_STATUS, USER_STATUS } from "./constants";

export function getUserFromStorage() {
  const raw = localStorage.getItem("cm_user");
  return raw ? JSON.parse(raw) : null;
}

export function getAuthStatus() {
  const user = getUserFromStorage();
  if (!user?.token) return USER_STATUS.UNAUTH;
  return user.status || USER_STATUS.UNVERIFIED;
}

export function landingPathFor(status) {
  return LANDING_BY_STATUS[status] ?? "/";
}
